import { S as array } from './Either-48abb652.js';
import { L as Lens, f as fromTraversable } from './index-a60c253d.js';
import { isDraftContent, isRichContent } from './types/contentTypes.js';
import { extract } from './RicosContentAPI/extract.js';
import './ReadonlyNonEmptyArray-0e481d0b.js';
import './ReadonlyRecord-86a56753.js';
import './string-40bcd6bf.js';
import 'lodash';
import 'ricos-schema';
import './extractor-infra.js';

function getContentLength(content) {
  if (isDraftContent(content)) {
    return getDraftTextLength(content);
  } else if (isRichContent(content)) {
    return getRichContentTextLength(content);
  }
  return NaN;
}
function getRichContentTextLength(content) {
  var _a;
  return extract((_a = content.nodes) != null ? _a : []).map(({ textData }) => (textData == null ? void 0 : textData.text) || "").get().reduce((count, line) => count + line.length, 0);
}
function getDraftTextLength(content) {
  const blocksLens = Lens.fromProp()("blocks");
  const blockTraversal = fromTraversable(array)();
  const textLens = Lens.fromProp()("text");
  return blocksLens.composeTraversal(blockTraversal).composeLens(textLens).asFold().getAll(content).reduce((count, line) => count + line.length, 0);
}

export { getContentLength };
//# sourceMappingURL=getContentLength.js.map
